/*
 * @Author: Ashley.Liu
 * @Date: 2022-11-01 16:18:18
 * @LastEditTime: 2022-11-01 16:18:24
 * @Description: desc
 */
import 'codemirror/mode/sql/sql.js'
